import { isEditor } from "../../functions/isEditor";

export default function PrePin({ pinAnim, pinAnimStep }) {
  return (
    !isEditor && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          marginTop: -40,
          marginLeft: -9,
          width: 19,
          height: 43,
          overflow: "hidden",
        }}
      >
        <img
          src={pinAnim}
          style={{
            position: "absolute",
            left: pinAnimStep * -19,
            userSelect: "none",
            pointerEvents: "none",
          }}
          alt={"pinAnim"}
        />
      </div>
    )
  );
}
